import React, { useState } from 'react';
import { Shield, CheckCircle, XCircle } from 'lucide-react';
import { revokeAnalyticsConsent } from '../hooks/useAnalytics';
export function PrivacyControls() {
  const [hasConsent, setHasConsent] = useState(localStorage.getItem('analytics_consent') === 'true');
  const handleRevoke = () => {
    if (window.confirm('Are you sure you want to opt out of analytics? This will reload the page.')) {
      revokeAnalyticsConsent();
      setHasConsent(false);
    }
  };
  const doNotTrack = navigator.doNotTrack === '1' || (window as any).doNotTrack === '1' || (navigator as any).msDoNotTrack === '1';
  return <div className="inline-flex items-center gap-2 text-sm" data-id="element-56">
      <Shield className="w-4 h-4 text-gray-400" data-id="element-57" />
      {doNotTrack ? <span className="text-gray-400 flex items-center gap-1" data-id="element-58">
          <CheckCircle className="w-3 h-3" data-id="element-59" />
          DNT Enabled
        </span> : hasConsent ? <button onClick={handleRevoke} className="text-gray-400 hover:text-gray-600 transition-colors flex items-center gap-1" data-id="element-60">
          <XCircle className="w-3 h-3" data-id="element-61" />
          Opt Out of Analytics
        </button> : <span className="text-gray-400 flex items-center gap-1" data-id="element-62">
          <CheckCircle className="w-3 h-3" data-id="element-63" />
          Analytics Disabled
        </span>}
    </div>;
}